module.exports = __webpack_public_path__ + "img/cvv.fbbe11a.png";